import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const SignupTerms: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const token = (location.state as any)?.token;
  const preview = (location.state as any)?.preview;
  const user_type = (location.state as any)?.user_type;

  const [agreeTerms, setAgreeTerms] = useState(false);
  const [agreePrivacy, setAgreePrivacy] = useState(false);
  const [agreeThirdParty, setAgreeThirdParty] = useState(false);
  const [agreeMarketing, setAgreeMarketing] = useState(false);
  const [agreeAll, setAgreeAll] = useState(false);

  // 토큰이 없으면 처음부터 다시 시작
  useEffect(() => {
    if (!token || !preview) {
      navigate('/signup');
    }
  }, [token, preview, navigate]);

  // 전체 동의 체크박스 핸들러
  const handleAgreeAll = (checked: boolean) => {
    setAgreeAll(checked);
    setAgreeTerms(checked);
    setAgreePrivacy(checked);
    setAgreeThirdParty(checked);
    setAgreeMarketing(checked);
  };

  // 개별 체크박스 변경 시 전체 동의 상태 업데이트
  useEffect(() => {
    if (agreeTerms && agreePrivacy && agreeThirdParty && agreeMarketing) {
      setAgreeAll(true);
    } else {
      setAgreeAll(false);
    }
  }, [agreeTerms, agreePrivacy, agreeThirdParty, agreeMarketing]);

  const handleNext = () => {
    if (!agreeTerms || !agreePrivacy) {
      alert('필수 약관에 모두 동의해주세요.');
      return;
    }

    navigate('/signup/form', {
      state: {
        token,
        preview,
        user_type,
        agreements: {
          terms: agreeTerms,
          privacy: agreePrivacy,
          thirdParty: agreeThirdParty,
          marketing: agreeMarketing,
        }
      }
    });
  };

  if (!token || !preview) {
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <div className="flex-1 bg-gray-50 py-12 mt-20">
        <div className="max-w-5xl mx-auto px-4">
        {/* Contents Head */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <h3 className="text-3xl font-bold text-gray-900">통합회원가입</h3>
            <div className="flex gap-4 text-sm">
              <Link to="/login" className="text-gray-600 hover:text-[#48c9a6]">로그인</Link>
              <Link to="/signup" className="text-[#48c9a6] font-medium">통합회원가입</Link>
            </div>
          </div>
          <div className="h-1 bg-[#48c9a6] w-20 mt-4"></div>
        </div>

        {/* Contents Body */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
          {/* 약관 동의 타이틀 */}
          <div className="mb-8 pb-4 border-b border-gray-200">
            <span className="text-xl font-bold text-gray-900">약관 동의</span>
          </div>

          {/* 전체 동의 */}
          <div className="mb-6 p-4 bg-[#48c9a6]/10 border-2 border-[#48c9a6] rounded-lg">
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={agreeAll}
                onChange={(e) => handleAgreeAll(e.target.checked)}
                className="w-5 h-5 text-[#48c9a6] border-gray-300 rounded focus:ring-[#48c9a6]"
              />
              <span className="ml-3 text-base font-bold text-gray-900">
                전체 약관에 동의합니다
              </span>
            </label>
          </div>

          {/* 이용약관 (필수) */}
          <div className="mb-6">
            <div className="flex items-center gap-3 mb-3">
              <h4 className="terms-title text-lg font-bold text-gray-900">이용약관</h4>
              <span className="text-sm font-medium text-red-600">(필수)</span>
            </div>
            <div className="border border-gray-300 rounded-lg p-4 h-64 overflow-y-auto bg-gray-50 text-sm text-gray-700 leading-relaxed mb-3" tabIndex={0}>
              <div className="space-y-4">
                <div>
                  <h5 className="font-bold text-gray-900 mb-2">제 1장 총칙</h5>
                  <div className="mb-3">
                    <p className="font-semibold">제 1조(목적)</p>
                    <p>이 약관은 회원이 동두천시 글로벌인재교육센터에서 운영하는 사이트가 제공하는 인터넷 관련 서비스(이하 "서비스"라 합니다)를 이용함에 있어 이용조건 및 절차와 이용자의 권리와 의무 및 책임사항을 규정함을 목적으로 합니다.</p>
                  </div>
                  <div className="mb-3">
                    <p className="font-semibold">제 2조(약관의 효력 및 변경)</p>
                    <p className="mb-1">1. 이 약관은 서비스내의 게시판을 통하여 공지함으로써 효력을 발생하며, 합리적인 사유가 발생할 경우 법령에 위배되지 않는 범위 안에서 개정될 수 있습니다.</p>
                    <p className="mb-1">2. 회원은 변경된 약관에 동의하지 않을 경우 회원 탈퇴를 요청할 수 있으며, 변경된 약관의 효력 발생일로부터 7일 이후에도 거부의사를 표시하지 아니하고 서비스를 계속 사용할 경우 약관의 변경 사항에 동의한 것으로 간주됩니다.</p>
                  </div>
                  <div className="mb-3">
                    <p className="font-semibold">제 3조(약관 외 내용)</p>
                    <p>이 약관은 동두천 글로벌인재교육센터가 제공하는 개인정보 보호정책과 함께 적용하며, 이 약관에서 규정하지 않은 사항에 대해서는 관련법령에서 정한 규정을 따릅니다.</p>
                  </div>
                </div>

                <div>
                  <p className="font-semibold">부칙</p>
                  <p>(시행일) 본 약관은 2025년 00월 00일부터 적용됩니다.</p>
                </div>
              </div>
            </div>
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={agreeTerms}
                onChange={(e) => setAgreeTerms(e.target.checked)}
                className="w-4 h-4 text-[#48c9a6] border-gray-300 rounded focus:ring-[#48c9a6]"
              />
              <span className="ml-2 text-sm text-gray-700">이용약관에 동의하십니까?</span>
            </label>
          </div>

          {/* 개인정보 수집, 이용 동의 (필수) */}
          <div className="mb-6">
            <div className="flex items-center gap-3 mb-3">
              <h4 className="terms-title text-lg font-bold text-gray-900">개인정보 수집, 이용 동의</h4>
              <span className="text-sm font-medium text-red-600">(필수)</span>
            </div>
            <div className="border border-gray-300 rounded-lg p-4 h-64 overflow-y-auto bg-gray-50 text-sm text-gray-700 leading-relaxed mb-3" tabIndex={0}>
              <div className="space-y-4">
                <div>
                  <h5 className="font-bold text-gray-900 mb-2">개인정보 수집, 이용 안내</h5>
                  <div className="mb-3">
                    <p className="font-semibold">1. 개인정보의 수집·이용목적</p>
                    <p className="mb-2">동두천 글로벌인재교육센터는 개인정보보호법 시행에 따라 개인정보 수집과 관련된 고객님의 동의를 획득하고 있습니다.</p>
                    <p className="mb-1">① 화상서비스 제공: 화상관리 서비스 제공, 화상서비스 이용이력 저장, 관리학습 결과 저장 및 학부모 피드백을 위한 목적</p>
                    <p className="mb-1">② 회원 가입 및 관리: 서비스 이용에 따른 본인확인, 개인 식별, 만14세 미만 아동 개인정보 수집 시 법정대리인 동의 여부 확인</p>
                    <p>③ 마케팅 및 광고에의 활용: 이벤트 정보 및 참여기회 제공, 광고성 정보 제공 등</p>
                  </div>
                  <div className="mb-3">
                    <p className="font-semibold">2. 개인정보의 수집 항목</p>
                    <p className="mb-1">- 학습생 정보(필수): 아이디, 비밀번호, 이름, 생년월일, 성별, 학교명, 학년</p>
                    <p className="mb-1">- 학부모 정보(필수): 이름, 아이디, 비밀번호, 생년월일, 성별, 주소, 전화번호, 휴대폰번호, 이메일</p>
                    <p>- 기타 자동 생성 정보: 쿠키, 접속 일시</p>
                  </div>
                  <div>
                    <p className="font-semibold">3. 개인정보의 보유 및 이용기간</p>
                    <p>회원 탈퇴 시까지 (단, 관계법령에 따라 보존이 필요한 경우 해당 기간 동안 보관)</p>
                  </div>
                </div>
              </div>
            </div>
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={agreePrivacy}
                onChange={(e) => setAgreePrivacy(e.target.checked)}
                className="w-4 h-4 text-[#48c9a6] border-gray-300 rounded focus:ring-[#48c9a6]"
              />
              <span className="ml-2 text-sm text-gray-700">개인정보 수집 및 이용에 동의하십니까?</span>
            </label>
          </div>

          {/* 개인정보 제3자 제공 동의 (선택) */}
          <div className="mb-6">
            <div className="flex items-center gap-3 mb-3">
              <h4 className="terms-title text-lg font-bold text-gray-900">개인정보 제3자 제공 동의</h4>
              <span className="text-sm font-medium text-gray-600">(선택)</span>
            </div>
            <div className="border border-gray-300 rounded-lg p-4 h-48 overflow-y-auto bg-gray-50 text-sm text-gray-700 leading-relaxed mb-3" tabIndex={0}>
              <div className="space-y-3">
                <p>동두천 글로벌인재교육센터는 회원의 개인정보를 개인정보 보호정책에서 고지한 범위 내에서 이용하며, 동 범위를 초과하여 이용하거나 타인 또는 타기업, 기관에 제공하지 않습니다.</p>
                <div>
                  <p className="font-semibold mb-2">개인정보 제공 업체 및 내용</p>
                  <table className="w-full border-collapse border border-gray-300">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="border border-gray-300 p-2">수탁업체</th>
                        <th className="border border-gray-300 p-2">위탁업무 내용</th>
                        <th className="border border-gray-300 p-2">제공 항목</th>
                        <th className="border border-gray-300 p-2">보유기간</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-gray-300 p-2">(주)한원글로벌</td>
                        <td className="border border-gray-300 p-2">교육서비스 정보 제공</td>
                        <td className="border border-gray-300 p-2">이름, 휴대폰 번호, 이메일</td>
                        <td className="border border-gray-300 p-2">회원탈퇴 시까지</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={agreeThirdParty}
                onChange={(e) => setAgreeThirdParty(e.target.checked)}
                className="w-4 h-4 text-[#48c9a6] border-gray-300 rounded focus:ring-[#48c9a6]"
              />
              <span className="ml-2 text-sm text-gray-700">개인정보 제3자 제공에 동의하십니까?</span>
            </label>
          </div>

          {/* 교육생 모집 활용 동의 (선택) */}
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-3">
              <h4 className="terms-title text-lg font-bold text-gray-900">교육생 모집 활용 동의</h4>
              <span className="text-sm font-medium text-gray-600">(선택)</span>
            </div>
            <div className="border border-gray-300 rounded-lg p-4 h-40 overflow-y-auto bg-gray-50 text-sm text-gray-700 leading-relaxed mb-3" tabIndex={0}>
              <div className="space-y-3">
                <p>고객님께서 동의하실 경우, 아래의 개인정보가 명시된 목적에 따른 마케팅 활용에 이용될 수 있으며, 본 사항에 동의하지 않더라도 회원가입이나 서비스 이용이 가능합니다.</p>
                <table className="w-full border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 p-2">이용목적</th>
                      <th className="border border-gray-300 p-2">이용항목</th>
                      <th className="border border-gray-300 p-2">보유기간</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 p-2">교육정보안내</td>
                      <td className="border border-gray-300 p-2">학부모 성명, 연락처, 자녀 학년, 이메일</td>
                      <td className="border border-gray-300 p-2">회원 탈퇴 또는 동의 해제 시까지</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={agreeMarketing}
                onChange={(e) => setAgreeMarketing(e.target.checked)}
                className="w-4 h-4 text-[#48c9a6] border-gray-300 rounded focus:ring-[#48c9a6]"
              />
              <span className="ml-2 text-sm text-gray-700">교육생 모집 활용에 동의하십니까?</span>
            </label>
          </div>

          {/* 안내 문구 */}
          <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-sm text-yellow-800">
              ⚠️ 필수 항목에 동의하지 않으실 경우 회원가입이 제한됩니다.
            </p>
          </div>

          {/* 버튼 영역 */}
          <div className="flex gap-3">
            <button
              onClick={() => navigate('/signup/verify', { state: { user_type } })}
              className="flex-1 py-3 px-4 border border-gray-300 text-base font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 transition-colors"
            >
              이전 단계
            </button>
            <button
              onClick={handleNext}
              disabled={!agreeTerms || !agreePrivacy}
              className="flex-1 py-3 px-4 border border-transparent text-base font-medium rounded-lg text-white bg-[#48c9a6] hover:bg-[#3ab89a] disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
            >
              다음 단계
            </button>
          </div>
        </div>
      </div>
      </div>

      <Footer />
    </div>
  );
};

export default SignupTerms;
